export function capitalizeName(text: string) {
	const safeText = text || "";
	return safeText.replace(/caixa/gi, "CAIXA");
}

export function getCaixaExternalBillet(installment: any) {
	if (!installment) return;
	const props = installment.properties || [];
	return props.find((p: any) => p.key === "bill_url")?.stringValue;
}
